// extracted by mini-css-extract-plugin
export default {"overlay":"loader_overlay__BPNaa","spinner":"loader_spinner__jDssK","spin":"loader_spin__CVjh5","text":"loader_text__9VWMB","smallWrapper":"loader_smallWrapper__br5IX"};